import {
  Table,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr
} from "components"
import {
  ButtonCreate,
  ButtonDelete,
  DataStatus,
  Input
} from "components2"
import { Formik } from "formik"
import { ButtonGroup } from "react-bootstrap"
import * as Yup from "yup"

export const ListItemPerubahanData = ({
  data,
  showInputForm = true,
  showActionColumn = true,
  onClickDelete,
  onClickCreate,
}) => {
  return (
    <Table>
      <THead>
        <Tr>
          <ThFixed>No.</ThFixed>
          <Th>Atribut</Th>
          <Th>Nilai Saat Ini</Th>
          <Th>Nilai Baru</Th>
          <Th>Alasan Pengubahan</Th>
          {showActionColumn && <ThFixed>Aksi</ThFixed>}
        </Tr>
      </THead>

      <TBody>
        {showInputForm ? (
          <RowItemPerubahanData
            onClickCreate={onClickCreate}
          />
        ) : null}

        {data?.length ? (data?.map((e, index) => (
          <Tr key={index}>
            <TdFixed className="text-center">{index + 1}</TdFixed>
            <Td>{e.atribut_salah ?? "-"}</Td>
            <Td>{e.nilai_sebelum ?? "-"}</Td>
            <Td>{e.nilai_diminta ?? "-"}</Td>
            <Td>{e.alasan_pengubahan ?? "-"}</Td>
            {showActionColumn && (
              <TdFixed>
                <ButtonGroup>
                  <ButtonDelete
                    icon
                    noText
                    onClick={() => onClickDelete(e, index)}
                  />
                </ButtonGroup>
              </TdFixed>
            )}
          </Tr>
        ))
        ) : (
          <Tr>
            <Td colSpan={showActionColumn ? 6 : 5}>
              <DataStatus text="Tidak ada data" />
            </Td>
          </Tr>
        )}
      </TBody>
    </Table>
  )
}

function RowItemPerubahanData({ onClickCreate }) {
  return (
    <Formik
      enableReinitialize
      initialValues={{
        atribut_salah: "",
        nilai_sebelum: "",
        nilai_diminta: "",
        alasan_pengubahan: ""
      }}
      validationSchema={
        Yup.object({
          atribut_salah: Yup.string().required("Nama Atribut harus diisi"),
          nilai_sebelum: Yup.string().required("Nilai Saat Ini harus diisi"),
          nilai_diminta: Yup.string().required("Nilai Baru harus diisi"),
          alasan_pengubahan: Yup.string().required("Keterangan harus diisi")
        })
      }
      onSubmit={(value, { resetForm }) => onClickCreate(value, resetForm)}
    >
      {({ handleChange, handleSubmit, errors, touched, values }) => (
        <tr>
          <Td />
          <Td className="p-0">
            <Input
              noMargin
              name="atribut_salah"
              value={values.atribut_salah}
              onChange={handleChange}
              defaultValue={values.atribut_salah}
              error={touched.atribut_salah && errors.atribut_salah}
            />
          </Td>
          <Td>
            <Input
              noMargin
              name="nilai_sebelum"
              value={values.nilai_sebelum}
              onChange={handleChange}
              defaultValue={values.nilai_sebelum}
              error={touched.nilai_sebelum && errors.nilai_sebelum}
            />
          </Td>
          <Td>
            <Input
              noMargin
              name="nilai_diminta"
              value={values.nilai_diminta}
              onChange={handleChange}
              defaultValue={values.nilai_diminta}
              error={touched.nilai_diminta && errors.nilai_diminta}
            />
          </Td>
          <Td>
            <Input
              noMargin
              name="alasan_pengubahan"
              value={values.alasan_pengubahan}
              onChange={handleChange}
              defaultValue={values.alasan_pengubahan}
              error={touched.alasan_pengubahan && errors.alasan_pengubahan}
            />
          </Td>
          <Td>
            <ButtonCreate icon noText onClick={handleSubmit} />
          </Td>
        </tr>
      )}
    </Formik >
  )
}